<div class="setup-container">
  <!-- Camera Preview -->
  <div class="section">
    <h3 class="section-title camera">
      <i class="bi bi-camera-video-fill"></i> Camera Preview
      <span *ngIf="cameraReady" class="status live">● Live</span>
    </h3>

    <div class="camera-preview" [class.active]="cameraReady">
      <video #videoElement autoplay playsinline muted></video>
      <div class="overlay" *ngIf="!cameraReady">
        <i class="bi bi-camera-video"></i>
        <p class="status-text">Camera Ready to Test</p>
        <p class="sub-text">Click “Test Camera” below to preview</p>
      </div>
    </div>
  </div>

  <!-- Microphone Test -->
  <div class="section">
    <h3 class="section-title mic">
      <i class="bi bi-mic-fill"></i> Microphone Test
      <span *ngIf="micReady" class="status working">● Working</span>
    </h3>

    <div class="mic-box">
      <div class="mic-bar-bg">
        <div #micBar class="mic-bar" [style.width.%]="micLevel"></div>
      </div>
      <p class="mic-level">{{ micLevel }}%</p>
      <p class="mic-hint">Click “Test Microphone” to check audio levels</p>
    </div>
  </div>

  <!-- Control Buttons -->
  <div class="button-group">
    <button class="test-btn camera" (click)="testCamera()">
      <i class="bi bi-camera-video"></i> Test Camera
    </button>
    <button class="test-btn mic" (click)="testMicrophone()">
      <i class="bi bi-mic"></i> Test Microphone
    </button>
    <button class="test-btn refresh" (click)="refreshAll()">
      <i class="bi bi-arrow-repeat"></i> Refresh All
    </button>
  </div>

  <!-- System Status -->
  <div *ngIf="!allSystemsReady" class="notice-box warning">
    <i class="bi bi-exclamation-triangle-fill"></i>
    <div>
      <strong>Setup Required</strong>
      <p>Please test both your camera and microphone before continuing.</p>
    </div>
  </div>

  <div *ngIf="allSystemsReady" class="notice-box success">
    <i class="bi bi-check-circle-fill"></i>
    <div>
      <strong>All Systems Ready!</strong>
      <p>Your camera and microphone are working perfectly. You’re ready to start your interview.</p>
    </div>
  </div>

  <!-- Footer Help -->
  <div class="footer-help">
    <i class="bi bi-lightbulb-fill"></i>
    <p>
      <strong>Having issues? </strong>Having issues? Make sure you’ve allowed permissions for camera and microphone.
      Try refreshing the page or adjusting your browser settings.
    </p>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button class="back-btn" (click)="back.emit()"><i class="bi bi-arrow-left"></i> Back</button>
    <button class="continue-btn" (click)="onContinue()">
      Continue →
    </button>
  </div>
</div>